import React, { FC } from "react";
import { FormattedHTMLMessage } from "react-intl-phraseapp";
import { DrugCostInfo, Plan } from "../../../@types";
import {
  $$,
  normalizeNpi,
  shouldSuppressDrugPricing,
  useTranslate,
} from "../../../helpers";

interface PharmacyDrugCostsProps {
  drugCosts: DrugCostInfo;
  npi: string;
  plan: Plan;
}

export const pharmacyEstimatedYearlyDrugCostTestId =
  "pharmacy-estimated-yearly-drug-cost";

export const PharmacyDrugCosts: FC<PharmacyDrugCostsProps> = ({
  drugCosts,
  npi,
  plan,
}) => {
  const t = useTranslate();
  const suppressDrugPricing = shouldSuppressDrugPricing(plan.redactions);
  const thisNpi = normalizeNpi(npi);
  const pharmCosts = drugCosts.costs.find(
    pharmacy => normalizeNpi(pharmacy.npi) === thisNpi
  );
  return pharmCosts ? (
    <div className="ds-u-display--flex ds-u-flex-direction--column ds-u-lg-align-items--center e2e-pharmacy-drug-costs">
      <div className="ds-text-heading--sm ds-u-text-transform--uppercase ds-u-margin-bottom--05 ds-u-lg-text-align--center">
        <FormattedHTMLMessage
          id="pharm_selection.estimated_yearly_costs"
          tagName="span"
          values={{ year: plan.contract_year }}
        />
      </div>
      <div
        className="ds-text-heading--xl ds-u-font-size--xl ds-u-leading--heading ds-u-margin-top--0"
        data-testid={pharmacyEstimatedYearlyDrugCostTestId}
      >
        {suppressDrugPricing ? t("na") : $$(pharmCosts.estimated_yearly_total)}
      </div>
    </div>
  ) : null;
};
